import {ScoreCalculator} from '../common/score-calculator';
import {PlacedBin} from '../placed-bin';

export class OverlappingScoreCalculator extends ScoreCalculator {

    private static binsOverlap(placedBin1: PlacedBin, placedBin2: PlacedBin): boolean {
        const {x: x1, y: y1, right: right1, bottom: bottom1} = placedBin1;
        const {x: x2, y: y2, right: right2, bottom: bottom2} = placedBin2;

        return !(
            x1 > right2
            || x2 > right1
            || y1 > bottom2
            || y2 > bottom1
        );
    }

    private static getBinOverlappingAreaPercent(placedBin1: PlacedBin, placedBin2: PlacedBin): number {
        let percent: number = 0;

        if (OverlappingScoreCalculator.binsOverlap(placedBin1, placedBin2)) {
            const {x: x1, y: y1, w: w1, h: h1, right: right1, bottom: bottom1} = placedBin1;
            const {x: x2, y: y2, w: w2, h: h2, right: right2, bottom: bottom2} = placedBin2;

            const w = Math.max(0, Math.min(right1, right2) - Math.max(x1, x2));
            const h = Math.max(0, Math.min(bottom1, bottom2) - Math.max(y1, y2));
            const overlapArea = w * h;
            const binsArea = w1 * h1 + w2 * h2;

            percent = Math.round(overlapArea * 100 / binsArea);
        }

        return percent;
    }

    public override calc(placedBin: PlacedBin): number {
        return 100 - this.getMaxOverlappingAreaPercent(placedBin);
    }

    private getMaxOverlappingAreaPercent(placedBin: PlacedBin): number {
        return this.placedBins.reduce((maxValue, envBin) => {
            const percent = OverlappingScoreCalculator.getBinOverlappingAreaPercent(placedBin, envBin);

            return Math.max(percent, maxValue);
        }, 0);
    }

}
